import ErrorPage from 'yoda-app-shell/lib/components/ErrorFullPage/ErrorFullPageLazy';
import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    array,
    arrayOf,
    bool,
    func,
    number,
    object,
    objectOf,
    oneOfType,
    string,
} from 'prop-types';
import { get } from 'lodash';
import * as styles from './GalleryGrid.css';
import CertonaConnected from '../Certona/Certona';
import FilterContent from '../FilterContent/FilterContent';
import FilterHeaderConnected from '../FilterHeader/FilterHeader';
import GalleryCriteoZoneConnected from '../CriteoZone/GalleryCriteoZone';
import LoadPaginationConnected from '../Pagination/LoadPagination';
import NoGalleryResultsConnected from '../NoGalleryResults/NoGalleryResults';
import NoResultsCardConnected from '../NoResultsCard/NoResultsCard';
import NoSearchResults from '../NoSearchResults/NoSearchResults';
import ProductListConnected from '../Product/ProductList';
import SelectedFacetsConnected from '../SelectedFacets/SelectedFacets';
import SuggestedFiltersConnected from '../SuggestedFilters/SuggestedFilters';
import selectNoSearchResults from '../../selectors/NoSearchResults';
import { selectStatusCheck } from '../../selectors/fromState';
import { getGalleryGridContentWithIris } from '../../actions/GalleryIrisAction';
import {
    selectDisableOrphanProductsfeatureFlag,
    selectEnableDesktopViewForTabletLandscapeOrientation,
    selectEnableVisualRelatedSearch,
} from '../../selectors/FeatureFlag';
import { updateUrl, showHorizonalFilters, getPageType } from '../../utils';

const cx = classNames.bind(styles);

export class GalleryGrid extends PureComponent {
    static propTypes = {
        abTestEngagements: arrayOf(object).isRequired,
        actions: objectOf(func).isRequired,
        deviceType: objectOf(bool).isRequired,
        disableOrphanProducts: bool.isRequired,
        enableDesktopViewForTablet: bool.isRequired,
        enableVisualRelatedSearch: bool.isRequired,
        enableCriteoForGallery: bool,
        enableCriteoForSearch: bool,
        enableProductsLoader: bool,
        enableStickyFacet: bool,
        isDisplayPLPMedaliaSurvey: bool,
        isDisplaySRPMedaliaSurvey: bool,
        gridAds: oneOfType([object, string]),
        irisComponents: oneOfType([array, object]),
        irisComponentsWithoutGrid: oneOfType([array, object]),
        irisPropsData: oneOfType([array, object]),
        marketingSlot: oneOfType([array, object]),
        noResults: bool,
        searchStatus: number,
    };

    static defaultProps = {
        enableCriteoForGallery: false,
        enableCriteoForSearch: false,
        enableProductsLoader: false,
        enableStickyFacet: false,
        gridAds: {},
        irisComponents: {},
        irisComponentsWithoutGrid: {},
        irisPropsData: {},
        isDisplayPLPMedaliaSurvey: false,
        isDisplaySRPMedaliaSurvey: false,
        marketingSlot: [],
        noResults: false,
        searchStatus: null,
    };

    componentDidMount() {
        this.setGalleyMarketingTilesData();
    }

    componentDidUpdate(prevProps) {
        const { marketingSlot } = this.props;

        if (!(marketingSlot === prevProps.marketingSlot)) {
            this.setGalleyMarketingTilesData();
        }
    }

    onPageChange = (pageNumber, mktTiles, hasMarketingTiles) => {
        if (hasMarketingTiles) {
            updateUrl(null, { page: pageNumber, mktTiles });
        } else updateUrl(null, { page: pageNumber });
    };

    displayMedaliaSurvey = () => {
        const {
            isDisplaySRPMedaliaSurvey,
            isDisplayPLPMedaliaSurvey,
            irisPropsData: { pageType },
        } = this.props;
        const isSRP = (pageType === 'Search' || getPageType() === 's') && isDisplaySRPMedaliaSurvey;
        // added !__SERVER_ condition on serverside srp div id is replacing with plp div id
        if ((isSRP || isDisplayPLPMedaliaSurvey) && !__SERVER__) {
            return (
                <div
                    id={isSRP ? 'srp_survey_inline' : 'plp_survey_inline'}
                    className={cx('medalia-div', 'pb-2 pt-2 relative w-full')}
                    data-automation-id={isSRP ? 'srp_survey_link' : 'plp_survey_link'}
                />
            );
        }
        return '';
    };

    getGalleryData = () => {
        const {
            abTestEngagements,
            deviceType,
            deviceType: { isDesktop, isTablet },
            enableCriteoForGallery,
            enableDesktopViewForTablet,
            enableStickyFacet,
            noResults,
        } = this.props;

        const showHorizontal = showHorizonalFilters(abTestEngagements, deviceType);

        /*
         * __IS_MOBILE__ would be converted to props.deviceType.isMobile on server because of server's dynamic nature
         * so, we would need a Terser Plugin with mangle.properties options with property reserved=['props']
         * saying that it would mean that props constant would never be mangled allowing us to rely on a props constant in variable scope
         * which would be governed by our lint rule saying that if __IS_MOBILE__ is used there should be a props constant defined in scope
         *
         */
        if (isDesktop || (isTablet && enableDesktopViewForTablet)) {
            return !noResults ? (
                <>
                    {enableCriteoForGallery && <GalleryCriteoZoneConnected page="gallery" />}
                    <FilterHeaderConnected />
                    <div className="flex flex-row">
                        <FilterContent />
                        <section
                            className={cx('product-pane', 'pr-0', { sticky: enableStickyFacet })}
                        >
                            <NoResultsCardConnected />
                            {this.renderProductList()}
                            <LoadPaginationConnected onPageChange={this.onPageChange} />
                        </section>
                    </div>
                    {this.displayMedaliaSurvey()}
                    <CertonaConnected page="galleryRecZones" />
                </>
            ) : (
                <>
                    <NoGalleryResultsConnected />
                    {this.displayMedaliaSurvey()}
                </>
            );
        }

        return !noResults ? (
            <>
                {enableCriteoForGallery && <GalleryCriteoZoneConnected page="gallery" />}
                {this.renderFilters(showHorizontal)}
                <NoResultsCardConnected />
                {this.renderProductList()}
                <LoadPaginationConnected onPageChange={this.onPageChange} />
                {this.displayMedaliaSurvey()}
                <CertonaConnected page="galleryRecZones" />
            </>
        ) : (
            <>
                <NoGalleryResultsConnected />
                {this.displayMedaliaSurvey()}
            </>
        );
    };

    getSearchData = () => {
        const {
            abTestEngagements,
            deviceType,
            deviceType: { isDesktop, isTablet },
            enableCriteoForSearch,
            enableDesktopViewForTablet,
            enableStickyFacet,
            noResults,
            searchStatus,
        } = this.props;

        const showHorizontal = showHorizonalFilters(abTestEngagements, deviceType);

        // render 404 error page in case of unauthorized user
        if (searchStatus === 403) return <ErrorPage templateType="404" />;

        if (noResults)
            return (
                <>
                    <NoSearchResults />
                </>
            );

        // render that gallery grid only when there are no api response with gallery ()
        if (isDesktop || (enableDesktopViewForTablet && isTablet)) {
            return (
                <>
                    {enableCriteoForSearch && <GalleryCriteoZoneConnected page="search" />}
                    <SuggestedFiltersConnected />
                    <FilterHeaderConnected />
                    <div className="flex flex-row">
                        <FilterContent />
                        <section
                            className={cx('product-pane', 'pr-0', {
                                sticky: enableStickyFacet,
                            })}
                        >
                            <NoResultsCardConnected />
                            {this.renderProductList()}
                            <LoadPaginationConnected onPageChange={this.onPageChange} />
                        </section>
                    </div>
                    {this.displayMedaliaSurvey()}
                    <CertonaConnected page="searchRecZones" />
                </>
            );
        }

        return (
            <>
                {enableCriteoForSearch && <GalleryCriteoZoneConnected page="search" />}
                <SuggestedFiltersConnected />
                {this.renderFilters(showHorizontal)}
                <NoResultsCardConnected />
                {this.renderProductList()}
                <LoadPaginationConnected onPageChange={this.onPageChange} />
                {this.displayMedaliaSurvey()}
                <CertonaConnected page="searchRecZones" />
            </>
        );
    };

    getMarketingSlot = () => {
        const { marketingSlot } = this.props;
        let marketingSlotData = [];

        if (marketingSlot && marketingSlot.content && marketingSlot.content.items) {
            marketingSlotData = marketingSlot.content.items.filter((x) => x).slice(0, 2);
        }

        return marketingSlotData;
    };

    setGalleyMarketingTilesData = () => {
        const { actions, disableOrphanProducts, enableVisualRelatedSearch } = this.props;
        const marketingSlot = this.getMarketingSlot();

        actions.getGalleryGridContentWithIris({
            marketingSlot,
            disableOrphanProducts,
            enableVisualRelatedSearch,
        });
    };

    renderProductList = () => {
        const {
            enableProductsLoader,
            gridAds,
            irisComponents,
            irisComponentsWithoutGrid,
            irisPropsData,
        } = this.props;
        const productlistclass = enableProductsLoader ? 'relative' : '';
        return (
            <div id="gallery-product-list" className={productlistclass}>
                <ProductListConnected
                    gridAds={gridAds}
                    irisComponents={irisComponents}
                    irisComponentsWithoutGrid={irisComponentsWithoutGrid}
                    irisPropsData={irisPropsData}
                    marketingSlot={this.getMarketingSlot()}
                    productList={{}}
                />
            </div>
        );
    };

    renderFilters = (showHorizontal) =>
        showHorizontal ? (
            <SelectedFacetsConnected wrapperClass="align-center flex flex-no-wrap mb-1 overflow-y-scroll whitespace-no-wrap" />
        ) : (
            <FilterHeaderConnected />
        );

    render() {
        const {
            irisPropsData: { pageType },
        } = this.props;

        return pageType === 'Search' || getPageType() === 's'
            ? this.getSearchData()
            : this.getGalleryData();
    }
}

const mapStateToProps = (state) => ({
    abTestEngagements: state.context && state.context.abTestEngagements,
    deviceType: state.context && state.context.deviceType,
    disableOrphanProducts: selectDisableOrphanProductsfeatureFlag(state),
    enableCriteoForGallery: state.context.featureFlags.enableCriteoForGallery,
    enableCriteoForSearch: state.context.featureFlags.enableCriteoForSearch,
    enableDesktopViewForTablet: selectEnableDesktopViewForTabletLandscapeOrientation(state),
    enableProductsLoader: get(state, 'multiSelectFilter.enableProductsLoader', false),
    enableStickyFacet: state.context.featureFlags.enableStickyFacet,
    enableVisualRelatedSearch: selectEnableVisualRelatedSearch(state),
    isDisplayPLPMedaliaSurvey: get(state, 'context.featureFlags.isDisplayPLPMedaliaSurvey', false),
    isDisplaySRPMedaliaSurvey: get(state, 'context.featureFlags.isDisplaySRPMedaliaSurvey', false),
    noResults: selectNoSearchResults(state),
    searchStatus: selectStatusCheck(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getGalleryGridContentWithIris,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(GalleryGrid);
